import { webUtils } from "./web-utils.js";

$(document).ready(function () {
  const checkAndCleanupToken = () => {
    const authCookie = webUtils.getCookie("is_authenticated");

    if (!authCookie) {
      const isAuthenticated = authCookie === "true" || authCookie === true;

      if (!isAuthenticated && localStorage.getItem("token")) {
        localStorage.removeItem("token");
      }
    }
  };

  checkAndCleanupToken();
});
